export const API_PATH_ApiDeviceMgmtDeviceDriversInfoGet = '/services/devices-mgtm/apiDeviceMgmtDeviceDriversInfoGet';
